import {
  mockChannel,
  mockPosts,
  mockEngageChannel,
  mockAccount,
  mockOrganization,
} from '~/shared/mocking'

import { getCounters } from '~/modules/post/utils'
import { EMOJIS } from '~/app/constants'

/**
 *
 */
export default function mockDatabase() {
  const organizationId = 'buffer'
  const channelIds = [
    'bufferA',
    'bufferB',
    'bufferC',
    'bufferD',
    'bufferE',
    'bufferF',
  ]

  const postsChannel0 = mockPosts({ channel: channelIds[0], count: 100 })
  const postsChannel1 = mockPosts({ channel: channelIds[1], count: 100 })
  const postsChannel2 = mockPosts({ channel: channelIds[2], count: 100 })
  const postsChannel3 = mockPosts({
    channel: channelIds[3],
    count: 100,
    service: 'facebook',
  })
  const postsChannel4 = mockPosts({
    channel: channelIds[4],
    count: 100,
    service: 'facebook',
  })
  const postsChannel5 = mockPosts({
    channel: channelIds[5],
    count: 100,
    service: 'facebook',
  })

  // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; organizationId: st... Remove this comment to see the full error message
  const countersChannel0 = getCounters(postsChannel0)
  // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; organizationId: st... Remove this comment to see the full error message
  const countersChannel1 = getCounters(postsChannel1)
  // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; organizationId: st... Remove this comment to see the full error message
  const countersChannel2 = getCounters(postsChannel2)
  // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; organizationId: st... Remove this comment to see the full error message
  const countersChannel3 = getCounters(postsChannel3)
  // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; organizationId: st... Remove this comment to see the full error message
  const countersChannel4 = getCounters(postsChannel4)
  // @ts-expect-error TS(2345) FIXME: Argument of type '{ id: string; organizationId: st... Remove this comment to see the full error message
  const countersChannel5 = getCounters(postsChannel5)

  const organization = mockOrganization({
    override: {
      id: organizationId,
      channels: [
        mockChannel({
          override: {
            name: 'Buffer A',
            service: 'instagram',
            serviceId: channelIds[0],
            organizationId,
          },
        }),
        mockChannel({
          override: {
            name: 'Buffer B',
            service: 'instagram',
            serviceId: channelIds[1],
            organizationId,
          },
        }),
        mockChannel({
          override: {
            name: 'Buffer C',
            service: 'instagram',
            serviceId: channelIds[2],
            organizationId,
            isDisconnected: true,
          },
        }),
        mockChannel({
          override: {
            name: 'Buffer A',
            service: 'facebook',
            serviceId: channelIds[3],
            organizationId,
          },
        }),
        mockChannel({
          override: {
            name: 'Buffer B',
            service: 'facebook',
            serviceId: channelIds[4],
            organizationId,
          },
        }),
        mockChannel({
          override: {
            name: 'Buffer C',
            service: 'facebook',
            serviceId: channelIds[5],
            organizationId,
            isDisconnected: true,
          },
        }),
      ],
    },
  })

  const account = mockAccount({
    override: {
      currentOrganization: organization,
      organizations: [organization],
    },
  })

  return {
    account,
    userSettings: {
      showMarkAsReadWarningModal: true,
    },
    engageOrganization: {
      id: organizationId,
      channels: [
        mockEngageChannel({
          override: {
            id: channelIds[0],
            totalPendingComments: countersChannel0.totalPendingComments,
            labelsCount: countersChannel0.labels,
          },
        }),
        mockEngageChannel({
          override: {
            id: channelIds[1],
            totalPendingComments: countersChannel1.totalPendingComments,
            labelsCount: countersChannel1.labels,
          },
        }),
        mockEngageChannel({
          override: {
            id: channelIds[2],
            totalPendingComments: countersChannel2.totalPendingComments,
            labelsCount: countersChannel2.labels,
          },
        }),
        mockEngageChannel({
          override: {
            id: channelIds[3],
            totalPendingComments: countersChannel3.totalPendingComments,
            labelsCount: countersChannel3.labels,
          },
        }),
        mockEngageChannel({
          override: {
            id: channelIds[4],
            totalPendingComments: countersChannel4.totalPendingComments,
            labelsCount: countersChannel4.labels,
          },
        }),
        mockEngageChannel({
          override: {
            id: channelIds[5],
            totalPendingComments: countersChannel5.totalPendingComments,
            labelsCount: countersChannel5.labels,
          },
        }),
      ],
      emojis: EMOJIS,
    },
    posts: [
      ...postsChannel0,
      ...postsChannel1,
      ...postsChannel2,
      ...postsChannel3,
      ...postsChannel4,
      ...postsChannel5,
    ],
  }
}
